// import { useEffect, useState } from 'react';
import firebase from 'firebase/app';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import * as Sentry from '@sentry/node';
import { TriggerEvent } from 'services/hitchit/types/hike/HikeEvents';
import { triggerEventsTransform } from '../hikes/triggerEvents/triggerEventsTransform';
import { DEFAULT_EVENTS_QUERY_LIMIT } from '../defaultEventsQueryLimit';

export default function useHikeRelatedEvents({
  hikeId,
  limit,
}: {
  hikeId?: string;
  limit?: number;
}): {
  triggerEvents: TriggerEvent[];
} {
  const originalQuery = firebase
    .firestore()
    .collection('hikes')
    .doc(hikeId)
    .collection('triggerEvents')
    .orderBy('createdAt', 'desc');

  const [triggerEvents, , error] = useCollectionData<TriggerEvent>(
    // Safe by default: never stream the whole subcollection — cap at the
    // default limit (most recent first) when no explicit limit is passed.
    hikeId ? originalQuery.limit(limit ?? DEFAULT_EVENTS_QUERY_LIMIT) : undefined,
    {
      snapshotListenOptions: { includeMetadataChanges: true },
      transform: triggerEventsTransform,
    }
  );

  if (error) {
    console.error(error.message);
    Sentry.captureException(error.message);
    return { triggerEvents: [] };
  }

  return { triggerEvents: triggerEvents || [] };
}
